import { useTranslation } from '@/i18n';
import type { WorkLocation } from '@/store/useTimeclockStore';
import { WORK_LOCATIONS } from '@/utils/workLocation';

interface WorkLocationSelectProps {
  value: WorkLocation | null;
  onChange: (value: WorkLocation | null) => void;
}

/** Work location of a clock-in in the correction dialogs; empty means "not asked". */
export function WorkLocationSelect({ value, onChange }: WorkLocationSelectProps) {
  const { t } = useTranslation('timeclock');

  return (
    <select
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value ? (Number(e.target.value) as WorkLocation) : null)}
      aria-label={t('workLocation.label')}
      className="px-2 py-1 rounded-md bg-white border border-slate-200 text-[13px] text-slate-900 focus:outline-none focus:ring-2 focus:ring-[#00A871]/30 focus:border-[#00A871]/50"
    >
      <option value="">{t('workLocation.notAsked')}</option>
      {WORK_LOCATIONS.map(({ location, key }) => (
        <option key={key} value={location}>
          {t(`workLocation.${key}`)}
        </option>
      ))}
    </select>
  );
}
